module.exports = __webpack_public_path__ + "media/images/pages/fcr/concept-3b18ddbcb95c26f02902fc1b1ee4abac.png";